import { FaUserGroup } from "react-icons/fa6";
const Groups = () => {
  return (
    <div className="flex flex-grow justify-start p-1 h-full">
      <div className="flex flex-col flex-grow justify-between">
        <div className="flex justify-start items-center gap-[10px] border-gray-300 bg-white hover:bg-[#f3f3f3] mb-2 p-[10px] rounded-[10px] transition-all">
          <div className="flex justify-center items-center border-[#9d58dc] border-[2px] p-2 rounded-full w-10 h-10">
            <FaUserGroup className="h-10 text-[50px] text-purple-600" />
          </div>

          <div className="flex flex-col justify-center items-center">
            <h2 className="mt-0 font-medium text-black text-md">Gyno</h2>
          </div>
        </div>
        <div className="bg-gray-300 shadow-lg p-2 rounded w-full">
          Create Group
        </div>
      </div>
    </div>
  )
}

export default Groups;